import { userPartialUpdaterBuilder } from "../userPartialUpdaterBuilder";
import { LanguageFormik, MESSENGER_CONTEXT, validationLanguageSchema } from "./LanguageForm";

export const LanguageFormEdit = userPartialUpdaterBuilder(LanguageFormik, {
  validationSchema: validationLanguageSchema,
  messangerContext: MESSENGER_CONTEXT,
});
